import { render, staticRenderFns } from "./PriceManagementOccupy.vue?vue&type=template&id=63c7e128"
import script from "./PriceManagementOccupy.vue?vue&type=script&lang=js"
export * from "./PriceManagementOccupy.vue?vue&type=script&lang=js"
import style0 from "./PriceManagementOccupy.vue?vue&type=style&index=0&id=63c7e128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports